var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "mb-2 d-flex item",
      class: { current: _vm.isCurrent },
      style: _vm.styles,
      on: { click: _vm.onSelect },
    },
    [
      _c("div", { staticClass: "flex-grow-1" }, [
        _c("span", { staticClass: "item-title" }, [
          _vm._v(
            "\n              " +
              _vm._s(_vm._f("uppercase")(_vm.sendList.name)) +
              "\n          "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex-shrink-0" }, [
        _c("div", { staticClass: "d-inline-block" }, [
          _c("div", { staticClass: "dropdown" }, [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "dropdown-menu",
                attrs: { "aria-labelledby": "dropdownMenu2" },
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.onSendQuickMessage.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "far fa-comment-alt mr-3" }),
                    _vm._v("Sms\n          "),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "dropdown-item",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.showEmailBulkMessageForm.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-at mr-3" }),
                    _vm._v("Mail\n          "),
                  ]
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-purple",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onEdit.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "fas fa-edit" })]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-sm btn-danger",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.onDelete.apply(null, arguments)
              },
            },
          },
          [_c("i", { staticClass: "far fa-trash-alt" })]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "button",
      {
        staticClass: "btn btn-purple btn-sm dropdown-toggle",
        attrs: {
          type: "button",
          id: "dropdownMenu2",
          "data-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "false",
        },
      },
      [_c("i", { staticClass: "fas fa-paper-plane fa-fw pr-1" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }